import React from 'react';
import { Alert, AlertColor } from '@mui/material';
import toast, { ToastOptions } from 'react-hot-toast';

type ToastType = 'success' | 'error' | 'warning' | 'info';

// Map our toast types to MUI Alert severity
const toastTypeToAlertSeverity = (type: ToastType): AlertColor => {
    return type as AlertColor;
};

const defaultOptions: ToastOptions = {
    duration: 3000,
    position: 'top-right',
};

const createToast = (message: string, type: ToastType, options?: ToastOptions) => {
    return toast.custom((t) => (
        <Alert
            severity={toastTypeToAlertSeverity(type)}
            variant="filled"
            onClose={() => toast.dismiss(t.id)}
            sx={{
                maxWidth: '400px',
                boxShadow: 2,
                color: 'white',
                zIndex: 9999,
            }}
        >
            {message}
        </Alert>
    ), {
        ...defaultOptions,
        ...options,
    });
};

export const toastService = {
    success: (message: string, options?: ToastOptions) =>
        createToast(message, 'success', options),

    error: (message: string, options?: ToastOptions) =>
        createToast(message, 'error', options),

    warning: (message: string, options?: ToastOptions) =>
        createToast(message, 'warning', options),

    info: (message: string, options?: ToastOptions) =>
        createToast(message, 'info', options),

    dismiss: (toastId?: string) => {
        if (toastId) {
            toast.dismiss(toastId);
        } else {
            toast.dismiss();
        }
    },
};

export default toastService;
